<template>
  <VueFinalModal
      v-model="show"
      classes="watch-modal"
      content-class="watch-modal__content"
      name="watchModal"
      @before-open="catchParams"
      @closed="closed"
  >
    <template>
      <div class="watch-modal__content__container">
        <div class="iframe" v-html="resource.video_link"/>
      </div>
    </template>
  </VueFinalModal>
</template>
<script>
import {VueFinalModal} from 'vue-final-modal'
export default {
  components: {VueFinalModal},
  data() {
    return {
      show: false,
      resource: {},
    }
  },
  methods: {
    async catchParams(event) {
      this.resource = event.ref.params.resource
    },
    closed() {
      this.resource = {}
    }
  }
}
</script>
<style lang="scss">
.iframe {
  iframe {
    aspect-ratio: 16 / 9;
    width: 100%;
    height: 100%;
  }
}

.lang-trigger {
  width: 17px;
  height: 17px;
  background: #fff;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 10px;
  color: $darkGrey;
  text-transform: uppercase;
}

.lang-trigger-dropdown {
  display: grid;
  gap: 5px;

  &__option {
    display: flex;
    align-items: center;
    cursor: pointer;

    &__title {
      margin-left: 5px;
      text-transform: uppercase;
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 147.5%;
      color: #474747;
    }
  }
}

.watch-modal {
  display: flex;
  justify-content: center;
  align-items: center;

  &__content {
    max-width: 1024px;
    border-radius: 13px;
    width: 100%;
    background: #1A1A1A;
    overflow: hidden;

    &__container {
      display: flex;
      flex-direction: column;
    }

    &__footer {
      display: flex;
      align-items: center;
      flex: 0 1 auto;
      margin-top: auto;
      padding: 24px 42px 24px 24px;

      & > div:first-child {
        flex: 1;
      }

      &__time {
        font-weight: 400;
        font-size: 10px;
        line-height: 130%;
        color: #FFFFFF;
        margin-bottom: 2px;
      }

      &__title {
        font-weight: 700;
        font-size: 10px;
        line-height: 130%;
        color: #FFFFFF;
      }
    }
  }
}
</style>